import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import Head from "next/head";
import dynamic from "next/dynamic";
import getCommonLocales from "../../locales/locales_common";
import getErrorLocales from "../../locales/locales_error";
import getRemoveBgPageLocales from "../../locales/locales_remove_bg";
import style from "../photo-into-painting/picture-into-painting.module.scss";
import Layout from "../../components/layout";
import ServiceLayout from "../../components/illustration-service/ServiceLayout/ServiceLayout";
const DynamicServiceEditor = dynamic(() => import("../../components/illustration-service/ServiceEditor/ServiceEditor"), { ssr: false });

export default function IllustrationService({ image_url }) {
	const { locale, query } = useRouter();

	const [serviceEnabled, setServiceEnabled] = useState(false);

	const startService = () => {
		setServiceEnabled(true);
	};

	const closeService = () => {
		setServiceEnabled(false);
	};

	const dictionary = { ...getCommonLocales(locale), ...getErrorLocales(locale), ...getRemoveBgPageLocales(locale) };

	const pageLink = image_url ? `https://bgrem.ai/illustration-drawing/?image_url=${image_url}` : "https://bgrem.ai/illustration-drawing/";

	let title = dictionary["page_ai_illustration_generator_title"] || "AI Illustration Generator: Create Stunning Artwork Automatically";
	let description =
		dictionary["aI_illustration_description"] ||
		"Unlock your creativity with our AI-driven illustration creation tool. Easily generate beautiful illustrations and artwork with AI. No artistic skills required – bring your ideas to life effortlessly";
	let ogTitle = title;
	let ogDescription = description;

	useEffect(() => {
		if (query.create) setServiceEnabled(true);
	}, [query]);

	const getCanonicalLink = (locale) => {
		const enList = ["en", "ja", "ar"];

		if (enList.includes(locale)) {
			return `https://bgrem.ai/illustration-drawing/`;
		} else {
			return `https://bgrem.ai/${locale}/illustration-drawing/`;
		}
	};

	return (
		<Layout mainClassName={`remove_bg magic_bg avatar-layout`}>
			<Head>
				<title>{title}</title>
				<meta name="description" content={description} />
				<meta property="og:type" content="website" />
				<meta property="og:title" content={ogTitle} />
				<meta property="og:description" content={ogDescription} />
				<meta property="og:url" content={pageLink} />
				<meta property="og:image" content={image_url ? image_url : "https://bgrem.ai/seo/og-styling.jpg"} />
				<meta property="og:site_name" content="bgrem" />
				<meta property="og:locale" content="en_US" />
				<meta property="og:section" content={title} />
				<meta name="twitter:title" content={ogTitle} />
				<meta name="twitter:description" content={ogDescription} />
				<meta property="twitter:card" content="summary_large_image" />
				<meta property="twitter:image:src" content={image_url ? image_url : "https://bgrem.ai/seo/og-styling.jpg"} />
				<meta name="twitter:image" content={image_url ? image_url : "https://bgrem.ai/seo/og-styling.jpg"} />
				<link rel="canonical" href={getCanonicalLink(locale)} />
			</Head>
			<section className={`section magicBg avatar-layout ${style.avatar}`}>
				{serviceEnabled ? <DynamicServiceEditor dictionary={dictionary} locale={locale} closeService={closeService} /> : <ServiceLayout dictionary={dictionary} startService={startService} />}
			</section>
		</Layout>
	);
}

export async function getServerSideProps(context) {
	const image_url = context.query.image_url || null;
	return { props: { image_url } };
}
